import React, { useEffect } from 'react';
import { Wrapper } from './styled';
import { INVESTORS_NEIGHBOURHOOD_PAGE_SECTIONS, InvestorSection } from './config';
import { Route, State as RouteState } from 'config/routes';
import { PortalOutput } from 'utils/universalPortal';

interface Props {
  activeSection: InvestorSection;
  setActiveSection: (section: InvestorSection) => void;
  route: RouteState;
}

// this sticky bar always sits under the 60px old Header: the 80px v2 header only renders on the
// home page, where this nav doesn't render at all, so the sticky offset is always 60
export const Subheader: React.FC<Props> = props => {
  const { activeSection, setActiveSection, route } = props;

  useEffect(() => {
    const el = document.querySelector(`[data-investor-subheader-nav="${activeSection}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [ activeSection, setActiveSection ]);

  let sections: InvestorSection[] = [];

  switch (route.name) {
    case Route.InvestorsNeighbourhoodPage:
      sections = INVESTORS_NEIGHBOURHOOD_PAGE_SECTIONS;
      break;
  }

  if (!sections.length) return null;

  return (
    <Wrapper>
      {sections.map(section => (
        <PortalOutput key={section} ids={[ section ]} />
      ))}
    </Wrapper>
  );
};
